import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:2005';

// ===== Gems CRUD =====

export const getGems = () => {
    return fetch(`${BASE_URL}/gems`)
        .then(response => response.json());
};

export const getGem = async (id) => {
    try {
        const response = await fetch(`${BASE_URL}/gems/${id}`);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching gem:', error);
        return { status: 'error', message: 'Failed to fetch gem data' };
    }
};

export const createGem = (gem, uploadStatus, uploadMessage) => {
    return new Promise((resolve, reject) => {
        uploadStatus(true);
        uploadMessage('Creating Gem');
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        fetch(`${BASE_URL}/gems/create`, {
            method: 'POST',
            headers,
            body: gem,
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => {
                resolve(result);
                uploadStatus(false);
                uploadMessage('Created Gem Successfully ID : ' + result['id']);
            })
            .catch(error => reject(error));
    });
};

export const updateGem = (gem) => {
    return new Promise((resolve, reject) => {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        fetch(`${BASE_URL}/gems/update/`, {
            method: 'PUT',
            headers,
            body: gem,
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => resolve(result))
            .catch(error => reject(error));
    });
};

export const deleteGem = (id) => {
    return fetch(`${BASE_URL}/gems/delete/${id}`, { method: 'DELETE', redirect: 'follow' })
        .then(response => response.json());
};

// ===== Auth =====

export const authLogin = (email, password) =>
    axios.post(`${BASE_URL}/api/auth/login`, { email, password });

export const authRegister = (name, email, password) =>
    axios.post(`${BASE_URL}/api/auth/register`, { name, email, password });

export const authMe = (token) =>
    axios.get(`${BASE_URL}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } });

export const authWpLogin = (username, password) =>
    axios.post(`${BASE_URL}/api/auth/wp-login`, { username, password });

export const authWpMe = (token) =>
    axios.get(`${BASE_URL}/api/auth/wp-me`, { headers: { Authorization: `Bearer ${token}` } });

// ===== Logs =====

export const getLogs = () =>
    fetch(`${BASE_URL}/logs`).then(response => response.json());

// ===== eBay =====

export const getEbayAccessToken = () =>
    fetch(`${BASE_URL}/auth/ebay/accesstoken`).then(response => response.json());

export const postEbayRequest = (payload) => {
    const config = {
        method: 'post',
        url: `${BASE_URL}/api/ebay/trading`,
        headers: { 'Content-Type': 'application/json' },
        data: payload
    };
    return axios.request(config);
};
